import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'lfw-toolbar',
  templateUrl: './app-toolbar.component.html',
  styleUrl: './app-toolbar.component.scss',
  imports: [MatToolbarModule]
})
export class AppToolbarComponent {}
